import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import parsingLinkGcpToAws from "@/app/infrastructures/misc/common-library/ParsingLinkGcpToAws";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import resolveDhlLabelPrintUrl from "./resolveDhlLabelPrintUrl";

const openLabelPdfWithAuth = async (
  url: string,
  targetWindow?: Window | null
): Promise<void> => {
  const tab = targetWindow ?? window.open("about:blank", "_blank");

  MainAppController.showLoading();

  try {
    const resolvedUrl = parsingLinkGcpToAws(resolveDhlLabelPrintUrl(url));
    const headers = new Headers();
    headers.append("authorization", `Bearer ${getToken()}`);

    const response = await fetch(resolvedUrl, { headers });

    if (!response.ok) {
      const error: any = new Error(`HTTP ${response.status}`);
      error.response = { status: response.status };
      throw error;
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    if (tab) {
      tab.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }

    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
  } catch (error) {
    tab?.close();
    MainAppController.showErrorMessage(parsingErrorResponse(error));
    throw error;
  } finally {
    MainAppController.closeLoading();
  }
};

export default openLabelPdfWithAuth;
